import appConfig from '@/config/app';

const routes = {
	'login': '/account/login',
	'logout': '/account/logout',
	'reg': '/account/reg',

	'accountEdit': '/member/user/edit',
	'password': '/member/user/password',
	'memberIndex': '/member/index',
	'getUserInfo': '/member/user/info',

	'homepage':'/index',
	'verifyCode':'/front/verifyCode',
	'getAreaData': '/front/getArea',
	'frontSetting': '/front/setting',
	'suggestSave': '/suggest/save',
	
	'productList':'/product/index',

	'corpIntro':'/corp/index',

	'newsList':'/news/index',
	'newsDetail':'/news/detail',

	'jobDetail':'/job/detail',
	'jobApply':'/job/apply',

	'invoiceApply': '/member/invoice/apply',
	'invoiceInfo': '/member/invoice/info',
	'invoiceList': '/member/invoice/list',
	'invoiceDetail': '/member/invoice/detail',
	'offerInit': '/member/offer/init',
	'offerQuoted': '/member/offer/quoted',
	'offerOrder': '/member/offer/order',
	'offerGetSetting': '/member/offer/getSetting',
	'offerGetPunchingSetting': '/member/offer/getPunchingSetting',
	'offerGetPunchingPrice': '/member/offer/getPunchingPrice',
	'offerDynamicSurface': '/member/offer/dynSurface',
	'orderIndex': '/member/order/list',
	'orderYearly': '/member/order/yearly',
	'orderYearlyList': '/member/order/yearlyList',
	'orderProgress': '/member/order/progress',
	'orderDetail': '/member/order/detail',
	'orderViewInventory': '/member/order/viewInventory', 
	'orderPayDetail': '/member/order/payDetail',
	'shopingIndex':'/member/shoping/index',
	'shopingPayment':'/member/shoping/payment',
	'shopingCart':'/member/shoping/joinCart',
	'shopingChangeQuantity':'/member/shoping/changeQuantity',
	'shopingViewInventory':'/member/shoping/viewInventory',
	'shopingDelCart':'/member/shoping/delCart',
	'shopingPlaceOrder':'/member/shoping/placeOrder',
	'shopingChangeChecked':'/member/shoping/changeChecked',
}

Object.keys(routes).forEach(key => routes[key] = `${appConfig.api.host}${routes[key]}`);

export default routes


// WEBPACK FOOTER //
// ./src/config/apiRoute.js